import { compact, type Falsey } from "~/lib/lodash";

export const and = <T extends object>(conditions: (T | Falsey)[]) => {
  return { AND: compact(conditions) };
};
